import EmailVerifiedContainer from "../components/pageComponents/Login/EmailVerifiedContainer";

const EmailVerified=()=>{
    return(
    <div><EmailVerifiedContainer /></div>);
}
export default EmailVerified;